import styled from 'styled-components';

import Row from 'components/common/Row';
import Text from 'components/common/Text';
import Column from 'components/common/Column';

import { FilterStatus } from './SaleProductSection';

const SelectButton = styled.button<{ $isSelected: boolean }>`
  padding: 10px 16px;

  border-radius: 8px;
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;

  ${({ $isSelected }) => {
    return {
      backgroundColor: $isSelected
        ? 'rgba(65, 75, 86, 1)'
        : 'rgba(247, 247, 248, 1)',
      color: $isSelected ? 'rgba(255, 255, 255, 1)' : 'rgba(152, 155, 162, 1)',
    };
  }}
`;

const STATUS_LIST: {
  id: FilterStatus;
  name: string;
}[] = [
  {
    id: 'all',
    name: '전체',
  },
  {
    id: 'payment',
    name: '결제완료',
  },
  {
    id: 'cancel',
    name: '결제취소',
  },
];

interface Props {
  selectedFilterStatus: FilterStatus;
  handlePaymentState: (status: FilterStatus) => void;
  isMobile: boolean;
}

function PaymentState({
  selectedFilterStatus,
  handlePaymentState,
  isMobile,
}: Props) {
  return (
    <Row
      gap="12px"
      justifyContent="flex-start"
      style={{
        marginBottom: '24px',
        padding: isMobile ? '0px 20px' : '0px 40px',
      }}
    >
      {STATUS_LIST.map((status, idx) => (
        <SelectButton
          key={`${status.id}-${idx}-${status.name}`}
          $isSelected={status.id === selectedFilterStatus}
          onClick={() => handlePaymentState(status.id)}
        >
          {status.name}
        </SelectButton>
      ))}
    </Row>
  );
}

export default PaymentState;
